
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";
import FormGroup from "@/components/form/FormGroup.vue";

@Component({
  components: {
    ModalFullScreen,
    FormGroup,
    FormTextarea,
  },
})
export default class NoteDisplayModel extends Vue {
  @Prop({ type: String, required: false, default: "Comments" })
  readonly title!: string;
  @Prop({ type: String, required: false, default: "" })
  readonly comment!: string;
}
